var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"design",class:{
            primary: _vm.isPrimary,
            secondary: _vm.isSecondary,
            'secondary-variant': _vm.isSecondaryVariant
        },attrs:{"align":"center","justify":"center"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }